import React from "react";
import { CmCollectionType } from "../../types";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOContainer from "../../fundamentals/CCOContainer";
import TeaserCard from "../C020TeaserCarousel/TeaserCard";
import {getContentClassName} from "../C020TeaserCarousel/C020TeaserCarousel";
import {getKey} from "../../../utility/componentUtil";
import useWindowSize from "../../../utility/useWindowSize";

export interface Props {
    cmCollection: CmCollectionType;
}

function C090ImageTextTeaserGrid({cmCollection}: Props) {
    const {id, teaserTitle, teaserText} = cmCollection;
    const {greaterThanWindowLarge, isWindowMedium} = useWindowSize();

    const columns = greaterThanWindowLarge ? 3 : isWindowMedium ? 2 : 1;
    const contentClassName = getContentClassName(getKey(id));

    return (
        <CCOComponentWrapper background="grey">
            <CCOHeadline
                metadataId={id}
                id={id}
                type="componenthead"
                headline={teaserTitle}
                propertyName="properties.teaserTitle"
                subtextPropertyName="properties.teaserText"
                subtext={teaserText?.textAsTree}
            />

            <CCOContainer width="large">
                <div
                    className="grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${columns}, 1fr)`,
                        gap: 24,
                    }}
                >
                    {(cmCollection.items ?? []).map((item, index) => {
                        if (!item) return null;

                        return (
                            <div
                                key={`${id}-${index}`}
                                className={contentClassName}
                                style={{display: "flex", alignItems: "stretch"}}
                            >
                                <TeaserCard item={item} horizontal={false} hideRoofline/>
                            </div>
                        );
                    })}
                </div>
            </CCOContainer>
        </CCOComponentWrapper>
    );
}

export default C090ImageTextTeaserGrid;